import { getDescendantCodes } from "@l2r-front/l2r-utils"

import { useVerticalSignTypes } from "../queries/verticalSigning/useVerticalSignTypes"

export function useVerticalSignDescendantCodes(code) {
    const { data: verticalSignTypes } = useVerticalSignTypes()

    return getDescendantCodes(code, verticalSignTypes)
}